import * as angular from 'angular';
import { Decimal } from 'decimal.js';

(function () {
    'use strict';

    /**
     * @ngdoc directive
     * @name pkpPriceTickValidator
     * @memberof app
     *
     * @restrict A
     * @require ngModel
     *
     * @description
     * Short term auctions have a minimum price step. The use is only allowed to submit surcharges that are multiples
     * of this value. These are called price ticks.
     *
     * @attr {PkpUseOriginals} pkpUseOriginals
     * @attr {{tick: app.PriceDto[], unit: app.PriceUnitDto}} pkpPriceTickValidator
     * @attr {app.PriceDto[]} pkpPriceTickValidator.tick The multi-currency price tick.
     * @attr {app.PriceUnitDto} pkpPriceTickValidator.unit The currency that should be used from `pkpPriceTickValidator.tick`.
     *
     * @author flzemke.btc
     */
    angular
        .module('app')
        .directive('pkpPriceTickValidator', pkpPriceTickValidator);

    function pkpPriceTickValidator(auctionsOverviewService, fieldKeyService) {
        return {
            restrict: 'A',
            scope: false,
            require: 'ngModel',
            link: linkFn
        };

        function linkFn(scope, elem, attr, ngModelCtrl) {
            var fieldKey = fieldKeyService.initialize(attr.pkpUseOriginals);

            ngModelCtrl.$validators.pkpPriceTickValidator = function (
                modelValue
            ) {
                if (
                    !attr.pkpPriceTickValidator ||
                    !modelValue ||
                    ngModelCtrl.$isEmpty(modelValue.value)
                ) {
                    return true;
                }

                var param = scope.$eval(attr.pkpPriceTickValidator);
                /**
                 * @type {app.PriceDto[]}
                 */
                var priceTick = param.tick;
                /**
                 * @type {app.PriceUnitDto}
                 */
                var priceUnit = param.unit;
                /**
                 * @type {app.PriceDto}
                 */
                var priceWithMatchingUnit =
                    auctionsOverviewService.extractPriceWithMatchingUnit(
                        priceTick,
                        priceUnit,
                        !angular.isUndefined(attr.pkpUseOrignals)
                    );

                try {
                    var modelValueAsDecimal = new Decimal(modelValue.value);

                    if (
                        !modelValueAsDecimal
                            .modulo(
                                priceWithMatchingUnit[fieldKey.valueKey].value
                            )
                            .equals(new Decimal(0))
                    ) {
                        return false;
                    }
                } catch (e) {
                    return false;
                }

                return true;
            };

            attr.$observe('pkpPriceTickValidator', function () {
                ngModelCtrl.$validate();
            });
        }
    }
})();
